import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const timeFormatter = (second = 0) => {
  const m = `${parseInt(second / 60, 10)}`.padStart(2, 0);
  const s = `${second % 60}`.padStart(2, 0);
  return `${m}:${s}`;
};

const Timer = ({ initSecond = 240, timeOver, formatter = timeFormatter }) => {
  const [remine, setRemine] = useState(initSecond);
  useEffect(() => {
    let tid;
    let last = Date.now();
    function update() {
      const cost = Date.now() - last;
      const diff = parseInt(cost / 1000, 10);
      last = Date.now();
      tid = setTimeout(update, 1000);
      setRemine((fresh) => {
        const leftTime = fresh - diff;
        if (!(leftTime > 0)) {
          clearTimeout(tid);
          timeOver && timeOver();
          return 0;
        }
        return leftTime;
      });
    }
    update();
    return () => {
      clearTimeout(tid);
    };
  }, []);
  return (
    <span>{formatter(remine)}</span>
  );
};

Timer.propTypes = {
  timeOver: PropTypes.func,
  formatter: PropTypes.func,
  initSecond: PropTypes.number,
};

const memoized = React.memo(Timer);

export default memoized;
